import { useEffect, useState } from "react";
import api from "@/lib/api";

const prettyAction = (a) => (a || "").replace(/\./g, " · ").replace(/_/g, " ");

export default function AdminAuditLog() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/admin/audit-log").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const shown = q.trim()
    ? items.filter((i) => `${i.actor_name} ${i.action} ${i.entity_label} ${i.reason}`.toLowerCase().includes(q.toLowerCase()))
    : items;

  return (
    <div>
      <div className="flex items-end justify-between gap-4 flex-wrap mb-6">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">System</p>
          <h2 className="font-serif text-4xl tracking-tighter">Audit Log.</h2>
        </div>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search actor, action, reason…" className="underline-input w-64" />
      </div>

      {shown.length === 0 ? (
        <p className="font-serif text-2xl text-muted-foreground">No matching activity.</p>
      ) : (
        <div className="border-l border-foreground/20 pl-5 space-y-5">
          {shown.map((a) => (
            <div key={a.id}>
              <div className="flex items-baseline gap-3 flex-wrap">
                <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{new Date(a.at).toLocaleString("en-IN")}</span>
                <span className="font-mono text-[10px] uppercase tracking-widest text-foreground">{a.actor_name}</span>
                <span className="font-mono text-[9px] uppercase tracking-widest border border-foreground/25 px-1.5 py-0.5 text-[hsl(var(--accent))]">{prettyAction(a.action)}</span>
              </div>
              <p className="text-sm mt-1">
                {a.entity_type}{a.entity_label ? <span className="font-serif"> · {a.entity_label}</span> : null}
                {a.reason ? <span className="text-muted-foreground"> — “{a.reason}”</span> : null}
              </p>
              {a.after?.fields && <p className="font-mono text-[10px] text-muted-foreground mt-0.5">fields: {a.after.fields.join(", ")}</p>}
              {a.after?.approved && <p className="font-mono text-[10px] text-muted-foreground mt-0.5">approved: {(a.after.approved || []).join(", ") || "—"}{a.after.rejected?.length ? ` · rejected: ${a.after.rejected.join(", ")}` : ""}</p>}
              {a.after?.admin_roles && <p className="font-mono text-[10px] text-muted-foreground mt-0.5">roles: {(a.after.admin_roles || []).join(", ") || "none"}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
